export const allFormKeys = [
    'active',
    'otherAgency',
    'discipline',
    'firstName',
    'preferredName',
    'lastName',
    'emailAddress',
    'phoneNumber',
    'address',
    'address2',
    'city',
    'state',
    'zipcode',
    'country',
    'virtual',
    'comments',
    'mentorId',
    'supervisorId',
    'burmese',
    'chin',
    'falamChin',
    'hakhaChin',
    'matuChin',
    'tedimChin',
    'zanniatChin',
    'zopheiChin',
    'crioulo',
    'filipino',
    'french',
    'frenchCajun',
    'frenchCanadian',
    'haitainCreole',
    'german',
    'punjabi',
    'spanish',
    'vietnamese',
    'somali',
    'swahili',
    'oralMotorFeeding',
    'sensoryBasedFeeding',
    'gTubeToOral',
    'foodAversion',
    'motorTransitSwallowingDysfunction',
    'behavior',
    'specifyBehavior',
    'als',
    'signingExactEnglish',
    'handlingNDT',
    'gTubeComfortable',
    'ventComfortable',
    'passyMuirValve',
    'floortime',
    'infantMentalHealthCert',
    'fgrbiCohort',
    'abaCert',
    'kinesiotapingExp',
    'kinesiotapingCert',
    'aacComfort',
    'aacExperience',
    'aacCertification',
    'visualScheduleExperience',
    'pecs',
    'hannen',
    'assistativeTechnology',
    'orthoticsUse',
    'orthoticsAdjustment',
    'wheelchairSupport',
    'wheelchairTraining',
    'wheelchairFitting',
    'aquaticTherapy',
    'hippoTherapy',
    'autismExperience',
    'splinting',
    'weightedVestFitting',
    'primitiveReflexIntegration',
    'additionalExpertise',
    'additionalExpertiseMemo',
    'pictureLink',
    'serviceAvailibility'
]